import { render, staticRenderFns } from "./EmployerBilling.vue?vue&type=template&id=22a6ec76"
import script from "./EmployerBilling.vue?vue&type=script&lang=ts"
export * from "./EmployerBilling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports